import { MvLandscape } from './MvLandscape';

const DEFAULT_BANDS = [
  { color: 'var(--mv-eisblau-50)', top: 8, amplitude: 40 },
  { color: 'var(--mv-himmelblau)', top: 40, amplitude: 34, flip: true },
  { color: 'var(--mv-wasserblau)', top: 66, amplitude: 26 },
];

/**
 * The page-wide MV landscape: by default the same three areas that sit
 * behind the news belt on the home page (Eisblau 50 %, Himmelblau,
 * Wasserblau), for use on every page. Where it sits is up to the caller's
 * `className`; `bands` replaces the default shapes where a page needs them
 * fitted to its own layout.
 */
function PageLandscape({ className = '', bands = DEFAULT_BANDS }) {
  return (
    <MvLandscape
      className={['page-landscape', className].filter(Boolean).join(' ')}
      bands={bands}
    />
  );
}

export default PageLandscape;
